<template>
  <div class="company">
    <Header title="我的公司" :is-nav="true" style="background-color: #fff;"></Header>
    <div>
      <h1>企业信息</h1>
      <van-cell-group>
        <van-field label="公司名称" :value="form.companyName" readonly />
        <van-field label="法人" :value="form.legalRepresentative" readonly />
        <van-field label="注册省" :value="form.provinceName" readonly />
        <van-field label="注册城市" :value="form.cityName" readonly />
        <van-field label="注册区域" :value="form.registerRegion" readonly />
        <van-field label="注册地址" :value="form.companyAddress" readonly />
      </van-cell-group>
      <h1>认证信息</h1>
      <van-cell-group>
        <van-field label="实名认证状态" readonly :value="statusName" />
      </van-cell-group>
      <h1>业务信息</h1>
      <van-cell-group>
        <van-field label="业务类型" value="贸易商" readonly />
      </van-cell-group>
      <h1>开票信息</h1>
      <van-cell-group>
        <van-field label="开票地址" :value="form.invoiceAddress" readonly />
        <van-field label="开票电话" :value="companyPhone" readonly />
        <van-field label="开户银行" :value="form.bank" readonly />
        <van-field label="银行账号" :value="form.bankAccountNo" readonly />
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import transactionApi from "@/request/transactionApi";
export default {
   components: {
    Header,
  },
  data() {
     return {
       form: {},
      companyPhone:"",
      region: {
        provinceList: [],
        cityList: [],
        regionLevel: "1",
        parentCode: "",
      },
      status: "",
      statusName: "",
     }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {};
      transactionApi.getCompanyDetail(params).then((res) => {
        if (res.returnCode == "0") {
           this.form = res.result.companyAuthModel;
           this.companyPhone = res.result.companyMdmInfoModel.companyContactPhone;
           // 获取变更状态
          this.status=res.result.salesRelationList[0].companyStatus;
          //  this.status=='03'?'变更中':(status=='02'?'已变更':'未变更'
          if (this.status=='03') {
             this.statusName = "变更中"
          } else if(status=='02') {
            this.statusName = "已变更"
          } else {
             this.statusName = "未变更"
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },

  }
};
</script>
<style lang="stylus" scoped>
.company {
  background-color: #F0F1F5;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    padding: 32px 40px;
  }
  >>> .van-cell-group{
    padding: 0 40px
  }
  >>> .van-cell {
    height: 96px;
    padding: 0px;
    align-items: center;
  }

  >>> .van-cell__title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #666666;
  }

  >>> .van-field__control {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #333333;
    text-align: right;
  }
}

>>> .van-cell::after {
  border-bottom: 0.01rem solid #ccc;
  left:0
  right:0
}
</style>